import React, { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import ReferencialPicturesApp from 'referencial/components/files/ReferencialPicturesApp'
import { useParams } from 'react-router'
import { PATH_REFERENCIAL, PATH_REFERENCIAL_TAXON, PATH_REFERENCIAL_TAXON_LINK, TAXON_MAJ } from 'home/constants/RouteConstants'
import ReferencialFileAction from 'referencial/components/files/actions/ReferencialFileAction'

const TaxonPicturesApp = ({

}) => {
    const {
        taxon,
        taxons,
    } = useSelector(store => ({
        taxon: store.TaxonReducer.taxon,
        taxons: store.TaxonReducer.taxons,
    }), shallowEqual)

    const dispatch = useDispatch()
    const { code } = useParams()

    const path = '/TAXONS/'

    useTitle(() => [
        {
            title: i18n.referencials,
            href: PATH_REFERENCIAL,
        },
        {
            title: i18n.taxons,
            href: PATH_REFERENCIAL_TAXON,
        },
        {
            title: code + (taxon.latinName ? ` - ${taxon.latinName}` : ''),
            href: PATH_REFERENCIAL_TAXON_LINK + code,
        }, {
            title: i18n.picturesAndDocuments,
            href: `/referencial/taxon/${code}/picture`,
        }], [taxon, code])


    useEffect(() => {
        if (!taxons.length) {
            dispatch(ReferencialFileAction.fetchReferencialFiles(path))
        }
        if (code !== 'new') {
            dispatch(ReferencialFileAction.fetchReferencialFile(code, path))
        }
    }, [dispatch, code])

    return (
        <ReferencialPicturesApp
            code={code}
            path={path}
            type={TAXON_MAJ}
        />
    )
}

export default TaxonPicturesApp